import { Component, ViewChild } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { LoginService } from './common/services/Login.service';
import { Location } from "@angular/common";
import { SessionService } from './common/services/Session.service';
import { GoogleAnalyticsService } from './common/services/google-analytics.service';
import { RightOverlayComponent } from './layout-components/right-overlay/right-overlay.component';

declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  @ViewChild(RightOverlayComponent) roc!: RightOverlayComponent;

  invokerocMethod(data) {
    this.roc.injectData(data.contents,data.pageHeading);
  }


  title = 'FASB-UI';
  showLogin = true;
  acceptedCookie = false;
  currentRole = "";
  urlData: any;
  yScrollValue: number;
  backButtonClicked = false;
  scrollHeight = 0;
  navigationData = [];
  currentIdPosition = -1;
  lastCurrentIdPosition = -1;
  pdfBackup: boolean = false;

  constructor(
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private graphQlService: GraphqlService,
    public commonDataService: CommonDataService, private session: SessionService,
    private loginService: LoginService, private _analytics: GoogleAnalyticsService,
    private location: Location
  ) {

    this._analytics.init();
    if (this.route.url.includes("Login")) {
      window.location.reload();
    }
    // START : Code to Track Page View using gtag.js 
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (session.analticsTrackingId != undefined && session.analticsTrackingId != null && session.analticsTrackingId != "") {
        if (session.analticsTrackingId != "Disabled") {
          gtag('js', new Date());
          gtag('config', session.analticsTrackingId.split("~~~~")[0]);
          gtag('config', session.analticsTrackingId.split("~~~~")[1]);
        }
      }
      else {
        graphQlService.getAnalyticsTrackingId().subscribe(trackingId => {
          if (trackingId != "" && trackingId != "Disabled") {
            gtag('js', new Date());
            gtag('config', trackingId.toString().split("~~~~")[0]);
            gtag('config', trackingId.toString().split("~~~~")[1]);
            session.SetAnalticsTrackingIdValue(trackingId);
          }
        })
      }
    })

    this.location.subscribe((ev) => {
      this.backButtonClicked = true; this.crossPageNavigation = true;
    });


    this.route.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(data => {
        this.urlData = JSON.parse(JSON.stringify(data))
        if (this.urlData.urlAfterRedirects.split('/').includes("ASCpdfs") || this.urlData.urlAfterRedirects.split('/').includes("copy-right-ASCpdfs")
          || this.urlData.urlAfterRedirects.split('/').includes("terms-and-conditions-ASCpdfs")) {
          this.pdfBackup = true;
          this.showLogin = true;
          this.session.assignUserInfo(null);
        }
        else {
          this.pdfBackup = false;
          if (this.urlData.urlAfterRedirects.split('/').includes("Login")) {
            this.showLogin = true;
            this.loginService.deleteSession().subscribe();
            this.session.assignUserInfo(null);
          }

          if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
            this.loginService.getSession().subscribe(sessionData => {
              if (sessionData.user != undefined && sessionData.user != null && (!this.route.url.includes("Login"))) {
                this.session.assignUserInfo(sessionData.user);
                this.currentRole = sessionData.user.roles;
                this.showLogin = false;
              }
              else {
                if (!this.route.url.includes("Maintenance") && !this.route.url.includes("ASCpdfs")) {
                  (!this.route.url.includes("proViewLogin")) ? this.route.navigateByUrl("/Login") : this.route.navigateByUrl("/Login/proViewLogin"); this.showLogin = true;
                }
              }
              document.removeEventListener("contextmenu", function (e) {
                e.returnValue = true;
              }, false);
            })
          }
          else {
            if (this.session.userInfo.user != undefined && this.session.userInfo.user != null) {
              this.showLogin = false;
              this.currentRole = this.session.userInfo.user.roles;
            }
            document.removeEventListener("contextmenu", function (e) {
              e.returnValue = true;
            }, false);
          }
        }
      });

    //for forward and back
    this.route.events
      .pipe(
        filter(event => event instanceof NavigationStart)
      )
      .subscribe((data: NavigationStart) => {
        this.windowScrolled = false;
          this.urlData = JSON.parse(JSON.stringify(data))
          if (data.restoredState) {       // forward and back
            let navId = data.restoredState.navigationId;
            let newId = data.id;

            let replaceAt = this.navigationData.indexOf(navId);//getting the position of id from array where we navigated to
            this.navigationData[replaceAt] = newId;//replacing the id with the new id
            this.lastCurrentIdPosition = this.currentIdPosition;
            this.currentIdPosition = replaceAt;
            this.retainScrollPosition(data);
            this.IsWhatLinksHere = false;
          }
          else {            // when page change on click
            this.navigationData.push(data.id);
            this.lastCurrentIdPosition = this.currentIdPosition;
            this.currentIdPosition = this.navigationData.indexOf(data.id);
            this.retainScrollPosition(data);
          }
      });
  }
  windowScrolled: boolean = false;
  ShowTopButton(valueEmitted) {
    this.windowScrolled = valueEmitted;
  }

  crossPageNavigation: boolean = true;
  retainScrollPosition(data: any) {//scrollPositionRestoration
    if (this.backButtonClicked) {
      this.commonDataService.glossaryTermFromContentPageBackButton.next("");
      localStorage.setItem('backButtonClicked', 'true');//setting for pageviewer anchor functionality
      this.backButtonClicked = false;

      let scrollDataArray = JSON.parse(sessionStorage.getItem('scrollPositionRetentionData'));
      let top = document.getElementsByTagName('app-main-content')[0]?.scrollTop;
      let height = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
      if (top != undefined && height != undefined) {
        if (typeof scrollDataArray[this.lastCurrentIdPosition] !== 'undefined') {
          let previousScroll = scrollDataArray[this.lastCurrentIdPosition];
          if (top != previousScroll.scrollTop || height != previousScroll.scrollHeight) {
            scrollDataArray[this.lastCurrentIdPosition].scrollHeight = height;
            scrollDataArray[this.lastCurrentIdPosition].scrollTop = top;
            sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
          }
        } else {
          scrollDataArray.push({ scrollHeight: height, scrollTop: top });
          sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
        }
      }

      if (this.crossPageNavigation) {
        let currentScrollData = scrollDataArray[this.currentIdPosition];
        let animationCallback = function () {

          let mainContent = document.getElementsByTagName('app-main-content')[0];
          let mainWindowScrollHeight = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;

          if (data.url.includes('Login')) {//for login when clicked on back button
            sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify([]));
          }
          else if (data.url.includes('pendingcontentsystem')) {
            localStorage.setItem("IntegratePendingContent", "true")
          }
          else if (data.url.includes('showallinonepage') || data.url.includes('showallinonepageplus')) {//for show all in one page
            if (mainContent && currentScrollData != null && currentScrollData?.scrollHeight != null && currentScrollData?.scrollTop != null && currentScrollData?.scrollHeight === mainWindowScrollHeight) {
              document.getElementsByTagName('app-main-content')[0].scrollTop = currentScrollData.scrollTop;
            }
            else {
              setTimeout(() => {
                if (currentScrollData) {
                  currentScrollData.scrollHeight = mainWindowScrollHeight;
                }
              }, 6000);
              requestAnimationFrame(animationCallback);
            }
          }
          else {// for all other pages
            if (mainContent && currentScrollData != null && currentScrollData?.scrollHeight != null && currentScrollData?.scrollTop != null && currentScrollData?.scrollHeight === mainWindowScrollHeight) {
              document.getElementsByTagName('app-main-content')[0].scrollTop = currentScrollData?.scrollTop;
            }
            else {
              setTimeout(() => {
                if (currentScrollData) {
                  currentScrollData.scrollHeight = mainWindowScrollHeight;
                }
              }, 6000);
              requestAnimationFrame(animationCallback);
            }
          }
        }
        let animationFrameRequestID = requestAnimationFrame(animationCallback);
        setTimeout(() => {
          window.cancelAnimationFrame(animationFrameRequestID);
        }, 10000);
      }
    }
    else {
      localStorage.setItem('backButtonClicked', 'false');//setting for pageviewer anchor functionality
      localStorage.setItem("IntegratePendingContent", "false");
      if (sessionStorage.getItem('scrollPositionRetentionData').length == 0) {
        let scrollDataArray = JSON.parse(sessionStorage.getItem('scrollPositionRetentionData'));
        for (let i = 0; i <= this.lastCurrentIdPosition; i++) {
          scrollDataArray.push({ scrollHeight: 0, scrollTop: 0 });
        }
        sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
      }
      if (data.url.includes('Login')) {//on logout
        sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify([]));
      }
      else {
        if (data.url == '/') {
          sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify([]));
        }
        else {
          let top = document.getElementsByTagName('app-main-content')[0]?.scrollTop;
          let height = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
          let scrollDataArray = JSON.parse(sessionStorage.getItem('scrollPositionRetentionData'));
          if (top != undefined && height != undefined) {

            if (typeof scrollDataArray[this.lastCurrentIdPosition] !== 'undefined') {
              let previousScroll = scrollDataArray[this.lastCurrentIdPosition];
              if (top != previousScroll.scrollTop || height != previousScroll.scrollHeight) {
                scrollDataArray[this.lastCurrentIdPosition].scrollHeight = height;
                scrollDataArray[this.lastCurrentIdPosition].scrollTop = top;
                sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
              }
            } else {
                scrollDataArray.push({ scrollHeight: height, scrollTop: top });
                sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
            }
          } else {
            for (let i = 0; i <= this.lastCurrentIdPosition; i++) {
              if (scrollDataArray.length < (i + 1)) {
                scrollDataArray.push({ scrollHeight: 0, scrollTop: 0 });
              }
            }
            sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
          }
        }
      }
    }
  }

  //RetainInPageScroll(scrollDataArray, position, lastPosition, url) {
  //  this.backButtonClicked = false;
  //  localStorage.setItem('backButtonClicked', 'false');
  //  var self = this;
  //  let currentScrollData = scrollDataArray[lastPosition];
  //  this.commonDataService.showLoader.next(true);
  //  let top = document.getElementsByTagName('app-main-content')[0]?.scrollTop;
  //  let height = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
  //  if (top != undefined && height != undefined) {
  //    if (!(typeof scrollDataArray[position] === 'undefined')) {
  //      let previousScroll = scrollDataArray[position];
  //      if (top != previousScroll.scrollTop || height != previousScroll.scrollHeight) {
  //        scrollDataArray[position].scrollHeight = height;
  //        scrollDataArray[position].scrollTop = top;
  //        sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
  //      }
  //    } else {
  //      scrollDataArray.push({ scrollHeight: height, scrollTop: top, url: url });
  //      sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
  //    }
  //  }


  //  let animationCallback = function () {

  //    let mainContent = document.getElementsByTagName('app-main-content')[0];
  //    let mainWindowScrollHeight = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
  //    if (url.includes('showallinonepage')) {//for show all in one page
  //      if (mainContent && currentScrollData != null && currentScrollData?.scrollHeight != null && currentScrollData?.scrollTop != null && currentScrollData?.scrollHeight === mainWindowScrollHeight) {
  //        document.getElementsByTagName('app-main-content')[0].scrollTop = currentScrollData.scrollTop;
  //        self.commonDataService.showLoader.next(false);
  //      }
  //      else {
  //        setTimeout(() => {
  //          if (currentScrollData) {
  //            currentScrollData.scrollHeight = mainWindowScrollHeight;
  //          }
  //        }, 6000);
  //        requestAnimationFrame(animationCallback);
  //      }
  //    }
  //    else {// for all other pages
  //      if (mainContent && currentScrollData != null && currentScrollData?.scrollHeight != null && currentScrollData?.scrollTop != null && currentScrollData?.scrollHeight === mainWindowScrollHeight) {
  //        document.getElementsByTagName('app-main-content')[0].scrollTop = currentScrollData?.scrollTop;
  //        self.commonDataService.showLoader.next(false);
  //      }
  //      else {
  //        setTimeout(() => {
  //          if (currentScrollData) {
  //            currentScrollData.scrollHeight = mainWindowScrollHeight;
  //          }
  //        }, 6000);
  //        requestAnimationFrame(animationCallback);
  //      }
  //    }
  //  }

  //  let animationFrameRequestID = requestAnimationFrame(animationCallback);
  //  setTimeout(() => {
  //    window.cancelAnimationFrame(animationFrameRequestID);
  //  }, 10000);

  //}

  IsCrossRef: boolean;
  IsGlossary: boolean;
  IsWhatLinksHere: boolean;
  whatLinksHereBackButtonTitle: string = "";
  whatLinksHereBackButtonUrl: string = "";
  IsXbrl: boolean;
  isPendingContentPage: boolean = false;
  isArchive: boolean = false;

  ngOnInit() {
    if (!sessionStorage.getItem('scrollPositionRetentionData')) {
      sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify([]));
    }
    localStorage.setItem("DefaultSecView", "true");
    this.SetHighlightedBorder();

    let crossRefObj = this.commonDataService.crossreferencedParaID.getValue();
    this.IsCrossRef = crossRefObj?.paragraphID != "" && crossRefObj?.paragraphID != undefined ? true : false;

    // let glossaryTerm=this.commonDataService.glossaryTermFromContentPageBackButton.getValue();
    // this.IsGlossary = glossaryTerm != "" && glossaryTerm != undefined ? true : false;

    this.commonDataService.glossaryTermFromContentPageBackButton.subscribe(glossaryTerm => {
      this.IsGlossary = glossaryTerm != "" && glossaryTerm != undefined ? true : false;
    })
    if (this.route.url == '/') {
      sessionStorage.setItem("isLogin", "true");
    }
    this.IsXbrl = localStorage.getItem("xbrlReturnPathText") != null && localStorage.getItem("xbrlReturnPathLink") != null ? true : false;

    let whatLinksHereRouteValues = this.route?.getCurrentNavigation()?.extras?.state;
    if (whatLinksHereRouteValues != null && whatLinksHereRouteValues != undefined) {
      if (('backLabel' in whatLinksHereRouteValues) && ('backUrl' in whatLinksHereRouteValues)) {
        if (this.route.url.split("/")[2] != whatLinksHereRouteValues.backUrl.split("/")[2]) {
          this.IsWhatLinksHere = true;
          this.whatLinksHereBackButtonTitle = whatLinksHereRouteValues.backLabel?.replace("-null","");
          this.whatLinksHereBackButtonUrl = whatLinksHereRouteValues.backUrl;
        }
      }
      else {
        this.IsWhatLinksHere = false;
      }
    }
    else {
      this.IsWhatLinksHere = false;
    }
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {


      crossRefObj = this.commonDataService.crossreferencedParaID.getValue();
      this.IsCrossRef = crossRefObj?.paragraphID != "" && crossRefObj?.paragraphID != undefined ? true : false;

      this.commonDataService.glossaryTermFromContentPageBackButton.subscribe(glossaryTerm => {
        this.IsGlossary = glossaryTerm != "" && glossaryTerm != undefined ? true : false;
      })

      this.IsXbrl = localStorage.getItem("xbrlReturnPathText") != null && localStorage.getItem("xbrlReturnPathLink") != null ? true : false;
      this.commonDataService.backToXBRLActive.subscribe(backToXBRLActive => { 
        this.IsXbrl = localStorage.getItem("xbrlReturnPathText") != null && localStorage.getItem("xbrlReturnPathLink") != null && backToXBRLActive ? true : false;
      });

      whatLinksHereRouteValues = this.route?.getCurrentNavigation()?.extras?.state;
      if (whatLinksHereRouteValues != null && whatLinksHereRouteValues != undefined) {
        if (('backLabel' in whatLinksHereRouteValues) && ('backUrl' in whatLinksHereRouteValues)) {
          if (this.route.url.split("/")[2] != whatLinksHereRouteValues.backUrl.split("/")[2]) {
            this.IsWhatLinksHere = true;
            this.whatLinksHereBackButtonTitle = whatLinksHereRouteValues.backLabel?.replace("-null", "");
            this.whatLinksHereBackButtonUrl = whatLinksHereRouteValues.backUrl;
          }
        }
        else {
          this.IsWhatLinksHere = false;
        }
      }
      else {
        this.IsWhatLinksHere = false;
      }
      if (!this.route.url.includes(this.commonDataService.gotoUrl.getValue())) {
        this.commonDataService.gotoUrl.next("");
      }
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        this.titleService.setTitle(data.title)
      });
      this.SetHighlightedBorder();
    });
    this.commonDataService.acceptCookie.subscribe(data => {
      //if (data != null && data) {
      //this.graphQlService.getCookie().subscribe(value => {
      if (data != null && data) {
        this.acceptedCookie = data;
      }
      //});
      //}
    });
  }

  SetHighlightedBorder() {
    this.isPendingContentPage = false;
    this.isArchive = false;

    if (localStorage.getItem("isArchivePage")) {
      const isArchiveContentPage = document.getElementsByTagName("app-archive-page-viewer") as HTMLCollectionOf<HTMLElement>;
      this.isArchive = localStorage.getItem("isArchivePage") == "true" && isArchiveContentPage.length > 0 ? true : false;
      this.isPendingContentPage = false;
    }
  }

  ngAfterViewChecked() {
    if ((localStorage.getItem("isContentPage") || localStorage.getItem("isShowAllInOnePage")) && localStorage.getItem("isPendingContentPage") == 'true' && localStorage.getItem("isArchivePage") != "true") {
      var isContentPage = localStorage.getItem("isContentPage");
      this.isPendingContentPage = localStorage.getItem("isPendingContentPage") == 'true' && (isContentPage == "true" || localStorage.getItem("isShowAllInOnePage") == "true") ? true : false;
      // var url = this.urlData?.urlAfterRedirects;
      // this.isPendingContentPage = (this.isPendingContentPage && url && (url != "/MasterGlossary" && url != "/crossreference" && url != "/search" && url != "/supersededstandards" && url != "/aicpa" && url != "/pendingcontentsystem" && url != "/pendingcontentintegeration" && url != "/conceptsstatements" && url != "/pendingcontentsystemagreement" && url != "/pendingcontentsystemagreement" && url != "/tableOfContent")) ? true : false;
      localStorage.removeItem("isContentPage");
      localStorage.removeItem("isShowAllInOnePage");
    }
  }


  // ngAfterViewChecked() {
  //   var mainContentClassList = document.getElementsByTagName("app-main-content")[0]?.className;
  //   var url = this.urlData?.urlAfterRedirects;
  //   if (mainContentClassList && url && (url == "/MasterGlossary" || url == "/crossreference" || url == "/search" || url == "/supersededstandards" || url == "/aicpa" || url == "/pendingcontentsystem" || url == "/conceptsstatements" || url == "/pendingcontentsystemagreement")) {
  //     if (!mainContentClassList.includes("overflow-hidden")) {
  //       mainContentClassList += " overflow-hidden";
  //     }
  //   }
  //   else {
  //     mainContentClassList = mainContentClassList?.replace(" overflow-hidden", "");
  //   }
  //   if (mainContentClassList) {
  //     document.getElementsByTagName("app-main-content")[0].className = mainContentClassList != undefined ? mainContentClassList : "";
  //   }

  //   var isContentPage = document.getElementsByTagName("app-page-viewer") as HTMLCollectionOf<HTMLElement>;
  //   var otherSourcePage= document.getElementsByTagName("app-othersource-content-viewer") as HTMLCollectionOf<HTMLElement>;
  //   var xbrlPage=document.getElementsByTagName("app-xbrl-content") as HTMLCollectionOf<HTMLElement>;
  //   var isShowAllInOnePage=document.getElementsByTagName("app-show-allin-one-page") as HTMLCollectionOf<HTMLElement>;
  //   this.isPendingContentPage = localStorage.getItem("isPendingContentPage") == 'true' && (isContentPage.length > 0 || isShowAllInOnePage.length > 0) && otherSourcePage.length == 0 && xbrlPage.length == 0 ? 'true' : 'false';

  //   var isArchiveContentPage=document.getElementsByTagName("app-archive-page-viewer") as HTMLCollectionOf<HTMLElement>;
  //   this.isArchive = localStorage.getItem("isArchivePage") == "true" && isArchiveContentPage.length > 0 ? true : false;
  // }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      var obj = this.getChild(activatedRoute.firstChild);
      return obj;
    } else {
      return activatedRoute;
    }

  }
}


